













































import {
  HistoricoProduto,
  HistoricosProdutosService
} from "@/services/historicos-produtos.service";
import DatePicker from "@/shared/components/date-picker.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    Loading,
    Modal,
    DatePicker,
    InputMoeda,
  },
})
export default class Manter extends Vue {
  historicoProduto = {} as HistoricoProduto;
  loading = false;

  rules = {
    codigoFornecedor: [required()],
    data: [required()],
    moeda: [required()],
  };

  get tituloManter(): string {
    if (this.historicoProduto) {
      return this.historicoProduto.idHistoricoProduto == null
        ? "Novo Histórico"
        : "Alterar Histórico";
    }
    return "";
  }

  async salvarHistorico() {
    this.loading = true;
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.historicoProduto.validoAte = dayjs(this.historicoProduto.validoAte)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
      await HistoricosProdutosService.manterHistoricoProduto(
        this.historicoProduto
      ).finally(() => (this.loading = false));
      modal.close(true);
    }
    this.loading = false;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarHistorico(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.historicoProduto = await HistoricosProdutosService.obter(id);
    this.loading = false;

    return p;
  }

  public async novoHistorico(idProduto: string) {
    const modal = this.$refs.modal as Modal;

    this.historicoProduto = {
      produto: { idProduto },
      validoDe: dayjs().startOf('month').format('MM/DD/YYYY'),
      validoAte: dayjs().endOf('month').format('MM/DD/YYYY'),
    } as HistoricoProduto;

    return modal.open();
  }
}
